export default {"src":"/_next/static/media/zebra-texture.3085e545.svg","height":316,"width":627,"blurWidth":0,"blurHeight":0};